<template>
    <div class="app-container">
        <div v-if="isLoadingStatus" />
        <div v-else>
            <a-card class="box-card">
                <div class="text item">
                    <a-steps v-if="currentNode.clazz !== undefined && currentNode.clazz !== null && currentNode.clazz !== ''" v-model:current="activeIndex">
                        <template v-for="(item, index) in nodeStepList">
                            <a-step :disabled="true" :key="index" :title="item.label" v-if="item.isHideNode == false ||
                  item.isHideNode == undefined ||
                  item.isHideNode == null ||
                  item.id == processStructureValue.workOrder.currentState" />
                        </template>
                    </a-steps>
                    <div v-else>
                        <a-alert message="未找到当前工单流程信息，请确认当前工单绑定的流程是否存在。" show-icon type="warning" />
                    </div>
                </div>
            </a-card>

            <a-alert :closable="false" :message="alertMessage" style="margin-top: 15px" type="error" v-if="activeIndex !== nodeStepList.length && processStructureValue.workOrder.isEnd==1" />

            <a-card class="box-card" style="margin-top: 15px">
                <div class="clearfix" slot="title">
                    <span>公共信息</span>
                </div>
                <div class="text item">
                    <a-form layout="inline">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="标题:" style="margin-bottom: 5px">
                                    <span>{{ processStructureValue.workOrder.title }}</span>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="优先级:" style="margin-bottom: 0">
                                    <span v-if="processStructureValue.workOrder.priority==2">
                                        <a-tag color="#faad14">紧急</a-tag>
                                    </span>
                                    <span v-else-if="processStructureValue.workOrder.priority==3">
                                        <a-tag color="#ff4d4f">非常紧急</a-tag>
                                    </span>
                                    <span v-else>
                                        <a-tag color="#52c41a">一般</a-tag>
                                    </span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
            </a-card>

            <a-card class="box-card" style="margin-top: 15px;">
                <div class="clearfix" slot="title">
                    <span>表单信息</span>
                </div>
                <div class="text item">
                    <template v-for="(tplItem, tplIndex) in processStructureValue.tpls">
                        <fm-generate-form :data="tplItem.formStructure" :key="tplIndex" :preview="!!((currentNode.hideTpls!==undefined &&
                            currentNode.hideTpls!==null &&
                            currentNode.hideTpls.indexOf(tplItem.formStructure.id)!==-1) ||
                            (currentNode.writeTpls==undefined ||
                            currentNode.writeTpls==null ||
                            currentNode.writeTpls.indexOf(tplItem.formStructure.id)==-1)||
                            (isActiveProcessing && currentNode.activeOrder))" :ref="'generateForm-'+tplItem.id" :remote="remoteFunc" :value="tplItem.formData" v-show="currentNode.hideTpls==undefined ||
                            currentNode.hideTpls==null ||
                            currentNode.hideTpls.indexOf(tplItem.formStructure.id)==-1" />
                    </template>
                </div>
                <div v-if="processStructureValue.userAuthority">
                    <hr style="background-color: #d9d9d9; border:0; height:1px; margin-bottom: 15px" />
                    <div>
                        <a-input :autosize="{ minRows: 3, maxRows: 99}" maxlength="200" placeholder="请输入备注信息" show-word-limit type="textarea" v-model="remarks" />
                    </div>
                    <div class="text item" style="text-align: center;margin-top:18px">
                        <div v-if="isActiveProcessing && currentNode.activeOrder">
                            <a-button @click="activeOrderActive" type="primary" v-permisaction="['process:list:handle:active']">主动接单</a-button>
                        </div>
                        <div v-else>
                            <template v-for="(item, index) in processStructureValue.edges">
                                <a-button :key="index" @click="submitAction(item)" type="primary" v-if="processStructureValue.workOrder.isEnd==0 && item.source==currentNode.id">{{ item.label }}</a-button>
                            </template>
                        </div>
                    </div>
                </div>
            </a-card>

            <a-card class="box-card" style="margin-top: 15px">
                <div class="clearfix" slot="title">
                    <span>工单流转历史</span>
                </div>
                <div class="text item">
                    <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :columns="columns" :dataSource="circulationHistoryList" class="j-table-force-nowrap">
                    </a-table>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { GenerateForm } from '@/components/VueFormMaking'
    import '@/components/VueFormMaking/styles/FormMaking.css'
    Vue.component(GenerateForm.name, GenerateForm)
    import { getAction } from '@/api/manage'
    import { getUserList } from '@/api/api'
    import { mapGetters } from 'vuex'
    import { validatenotnull, validatenull } from '@/utils/validate'
    export default {
        //处理工单
        name: 'HandleTicketIndex',
        data() {

            return {
                isLoadingStatus: true,
                currentNode: {
                    hideTpls: null,
                    writeTpls: null
                },
                isActiveProcessing: false,
                tpls: [],
                remarks: '', // 备注信息
                alertMessage: '',
                nodeStepList: [],
                circulationHistoryList: [],
                activeIndex: 0,
                processStructureValue: {
                    workOrder: { title: '' }
                },
                ruleForm: {
                    title: '',
                    process: '',
                    classifyId: '',
                    stateId: '',
                    state: '',
                    sourceState: '',
                    processor: '',
                    processMethod: '',
                    tpls: [],
                    tasks: []
                },
                remoteFunc: {
                    // 获取用户列表
                    userList(resolve) {
                        getUserList(Object.assign({ pageSize: 999999 })).then(res => {
                            const options = res.result.records
                            resolve(options)
                        })
                    }
                },
                // 表头
                columns: [{
                        title: '#',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 60,
                        align: "center",
                        customRender: function(t, r, index) {
                            return parseInt(index) + 1;
                        }
                    },
                    {
                        title: '节点',
                        align: "center",
                        dataIndex: 'state'
                    },
                    {
                        title: '流转',
                        align: "center",
                        dataIndex: 'circulationId'
                    },
                    {
                        title: '处理人',
                        align: "center",
                        dataIndex: 'processor'
                    },
                    {
                        title: '处理时间',
                        dataIndex: 'createTime',
                        align: "center"
                    },
                    {
                        title: '备注',
                        dataIndex: 'remarks',
                        align: "center"
                    }
                ],
                url: {
                    processStructureUrl: 'workorder/work-order/process-structure',
                }
            }
        },
        computed: {
            ...mapGetters([
                'userId'
            ])
        },
        created() {
            this.getProcessNodeList()
        },
        methods: {
            getProcessNodeList() {
                getAction(this.url.processStructureUrl, {
                    processId: this.$route.query.processId,
                    workOrderId: this.$route.query.workOrderId
                }).then((res) => {
                    if (res.success) {
                        this.isActiveProcessing = false
                        this.processStructureValue = res.result.records || res.result
                        this.circulationHistoryList = this.processStructureValue.circulationHistory
                        // 获取当前展示节点列表
                        this.nodeStepList = []
                        if (this.processStructureValue.nodes) {
                            for (var i = 0; i < this.processStructureValue.nodes.length; i++) {
                                if (this.processStructureValue.nodes[i].id == this.processStructureValue.workOrder.currentState) {
                                    // 当前节点
                                    this.nodeStepList.push(this.processStructureValue.nodes[i])
                                    this.activeIndex = this.nodeStepList.length - 1
                                    if (i + 1 == this.processStructureValue.nodes.length) {
                                        this.activeIndex = this.nodeStepList.length
                                    }
                                    this.currentNode = this.processStructureValue.nodes[i]
                                } else if (!this.processStructureValue.nodes[i].isHideNode) {
                                    // 非隐藏节点
                                    this.nodeStepList.push(this.processStructureValue.nodes[i])
                                }
                            }
                        }
                        // 如果回退到初始节点则可编辑。
                        if (this.activeIndex == 0 && this.currentNode.clazz == 'start') {
                            this.currentNode.writeTpls = []
                            for (var tplTmp of this.processStructureValue.tpls) {
                                this.currentNode.writeTpls.push(tplTmp.formStructure.id)
                            }
                        }
                        // 判断是否需要主动处理
                        for (var stateValue of this.processStructureValue.workOrder.state) {
                            if (this.processStructureValue.workOrder.currentState == stateValue.id && stateValue.processor.length > 1) {
                                this.isActiveProcessing = true
                                break
                            }
                        }
                        this.isLoadingStatus = false
                        this.getAlertMessage()
                    } else {
                        this.$message.warning(res.message)
                    }
                })
            },
            submitAction(item) {
                var promiseList = []
                this.tpls = []
                for (var tpl of this.processStructureValue.tpls) {
                    this.tpls.push({
                        tplDataId: tpl.id,
                        tplId: tpl.formStructure.id
                    })
                    promiseList.push(this.$refs['generateForm-' + tpl.id][0].getData())
                }
                Promise.all(promiseList).then(values => {
                    for (var tplDataIndex in this.tpls) {
                        this.tpls[tplDataIndex].tplValue = values[tplDataIndex]
                    }
                    handleWorkOrder({
                        tasks: this.processStructureValue.process.task,
                        sourceState: this.processStructureValue.workOrder.currentState,
                        targetState: item.target,
                        circulation: item.label,
                        flowProperties: item.flowProperties == undefined ? 2 : parseInt(item.flowProperties),
                        workOrderId: parseInt(this.$route.query.workOrderId),
                        remarks: this.remarks,
                        isExecTask: item.isExecuteTask,
                        tpls: this.tpls
                    }).then(res => {
                        if (res.code == 200) {
                            // this.$router.push({ name: 'upcoming' })
                            // window.location.reload()
                            this.getProcessNodeList()
                        }
                    })
                })
            },
            // 获取提示消息
            getAlertMessage() {
                if (this.processStructureValue.workOrder.isEnd == 1) {
                    this.alertMessage = '当前工单已结束。'
                }
            },
            activeOrderActive() {
                var jsonData = [{
                    id: this.nodeStepList[this.activeIndex].id,
                    label: this.nodeStepList[this.activeIndex].label,
                    processMethod: 'person',
                    processor: [this.userId]
                }]
                activeOrder(jsonData, this.$route.query.workOrderId).then(() => {
                    this.getProcessNodeList()
                })
            }
        }
    }
</script>